const oneDayExpiry = new Date(Date.now() + 24 * 60 * 60 * 1000);
const defaultPath = '/';

export const SAMESITE_STRICT_POLICY = 'Strict';
export const SAMESITE_LAX_POLICY = 'Lax';

export const COOKIE_SUBDOMAIN = '.vidacamara.cl';

export const DEFAULT_COOKIE_CONFIG = {
	expires: oneDayExpiry,
	subdomain: COOKIE_SUBDOMAIN,
	path: defaultPath,
	secure: true,
	SameSite: SAMESITE_LAX_POLICY,
};
